import loginTemplate from './login.html';

class LoginController {
  static $inject = ['$stateParams', 'AuthService', 'Timesheet'];

  credentials: any;
  isLoading: boolean;
  message: string;
  passwordError: string;
  emailError: string;

  constructor(
    private $stateParams,
    private AuthService,
    private Timesheet,
  ) {}

  $onInit() {
    this.credentials = {};
    this.isLoading = false;
    this.message = this.$stateParams.error;

    if (this.AuthService.isAuthenticated()) {
      this.Timesheet.gotoTimesheet();
    }
  }

  login() {
    this.message = null;
    this.passwordError = null;
    this.emailError = null;
    this.isLoading = true;

    this.AuthService.login(this.credentials)
      .then(() => this.Timesheet.gotoTimesheet())
      .catch((err) => {
        this.isLoading = false;
        if (err.status === 400) {
          this.passwordError = 'Le mot de passe est invalide';
        } else if (err.status === 404) {
          this.emailError = "L'adresse email est invalide";
        }
      });
  }
}

export const LoginComponent = {
    template: loginTemplate,
    controller: LoginController
};
